module.exports = __webpack_public_path__ + "img/aiwriter_generator2.546d79bb.jpg";